import { useEffect } from "react";
import { WidgetListeningEvents } from "../enums/WidgetEvents";
import { useAutocompleteSuggestionsContext } from "../contexts/AutocompleteSuggestions";

export const useAutocompleteSuggestionsEvents = () => {
  const { fetchAutocompleteSuggestions } = useAutocompleteSuggestionsContext();

  // Listeners
  useEffect(() => {
    window.addEventListener<any>(
      WidgetListeningEvents.RefreshAutocompleteSuggestions,
      fetchAutocompleteSuggestions
    );
    return () => {
      window.removeEventListener<any>(
        WidgetListeningEvents.RefreshAutocompleteSuggestions,
        fetchAutocompleteSuggestions
      );
    };
  }, [fetchAutocompleteSuggestions]);
};
